<script>
import Login from "@/components/login/login.vue";

export default {
  components: {
    Login,
  },
};
</script>

<template>
  <Login />
</template>
